import LayoutFluid from '../components/layout/layout_fluid'
import HeadTitle from '../components/head_title'
import Breadcrumbs from '../components/breadcrumbs'
import styles from '../styles/how_we_4ward.module.scss'

export default function HowWeForward() {
  return <LayoutFluid>
    <HeadTitle title="How We 4ward" />

    <div className={`bg-primary-gradient mb-4 ${styles.backdrop}`}>
      <div className={`container ${styles.container}`}>
        <Breadcrumbs
          currentPage="How We 4ward"
          className={styles.breadcrumbs}
          activeColor="white"
        />

        <h2 className={styles.title}>
          How do we <img src="/images/4ward-white.png" alt="illustration" className="align-baseline" />
          <br />
          your orders?
        </h2>

        <div className="row align-items-end">
          <div className="col text-left">
            <img src="/images/how_do_4ward_backdrop_left.png" alt="backdrop" className={styles.backdrop_left} />
          </div>
          <div className="col text-right">
            <img src="/images/how_do_4ward_backdrop_right.svg" alt="backdrop" className={styles.backdrop_right} />
          </div>
        </div>
      </div>
    </div>

    <div className="container mb-4">
      <h4 className="mb-0">How does</h4>
      <h4 className="mb-0">
        <span className="text-primary mr-2">Indo4ward</span>
        works? —
      </h4>

      <p className="w-100 w-md-75">
        Our platform serves as 2 different uses. Customers can purchase products that were processed by Indo4ward before, or they could simply provide us with a product link from an Indonesia marketplace!
      </p>

      <div className="row">
        <div className="col-md-5">
          <div className="card">
            <div className="card-body">
              <h4>Products on Indo4ward bought by other users</h4>
              <br />

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/teach-shop-icon.png" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Shop</strong>
                  <br />
                  Browse and shop for your desired items available on our e-commerce platform.
                  <br />
                  <img src="/images/arrow.svg" className={styles.arrow} alt="illustration" />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/payment.svg" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Payment</strong>
                  <br />
                  Review the items in your cart and proceed to payment to complete your purchase.
                  <br />
                  <img src="/images/arrow.svg" className={styles.arrow} alt="illustration" />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/process.svg" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Process</strong>
                  <br />
                  After payment is confirmed, we will coordinate with the seller to process your items and have them shipped to our designated warehouse.
                  <br />
                  <img src="/images/arrow.svg" className={styles.arrow} alt="illustration" />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/shipping.svg" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Ship</strong>
                  <br />
                  Once we receive your products, we will conduct an internal assessment in line with our policy before shipping them to you, no matter where you are!
                  <br />
                  <img src="/images/arrow.svg" className={styles.arrow} alt="illustration" />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/receive.svg" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Receive</strong>
                  <br />
                  Track and Receive your order!
                </div>
              </div>
            </div>
          </div>

          <img src="/images/shopping-bags.svg" alt="illustration" />
        </div>
        <div className="col-md-7">
          <div className="card">
            <div className="card-body">
              <h4>3rd Party Quotations - Found something else you want to buy?</h4>
              <br />

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/copy-paste.svg" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Copy-Paste</strong>
                  <br />
                  Spotted something you like on another marketplace? 
                  <br />
                  Simply copy and paste the item's link into our search bar.
                  <br />
                  <img src="/images/arrow.svg" className={styles.arrow} alt="illustration" />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/product-review.svg" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Product Review</strong>
                  <br />
                  We'll either retrieve the product details for you to proceed with checkout or allow you to request a quotation for the item.
                  <br />
                  <img src="/images/arrow.svg" className={styles.arrow} alt="illustration" />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/quotation.svg" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Quotation</strong>
                  <br />
                  We will provide you with a quotation for your requested item within 1-2 business days. You can then choose to proceed with the purchase or simply leave it in your shopping cart.
                  <br />
                  <img src="/images/arrow.svg" className={styles.arrow} alt="illustration" />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/payment.svg" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Payment</strong>
                  <br />
                  Review the items in your cart and proceed to payment to complete your purchase.
                  <br />
                  <img src="/images/arrow.svg" className={styles.arrow} alt="illustration" />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/process.svg" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Process</strong>
                  <br />
                  After payment is confirmed, we will coordinate with the seller to process your items and have them shipped to our designated warehouse.
                  <br />
                  <img src="/images/arrow.svg" className={styles.arrow} alt="illustration" />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/shipping.svg" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Ship</strong>
                  <br />
                  Once we receive your products, we will conduct an internal assessment in line with our policy before shipping them to you, no matter where you are!
                  <br />
                  <img src="/images/arrow.svg" className={styles.arrow} alt="illustration" />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-auto text-center">
                  <img src="/images/receive.svg" alt="illustration" className={styles.icon} />
                </div>
                <div className="col-sm">
                  <strong>Receive</strong>
                  <br />
                  Track and Receive your order!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </LayoutFluid>
}

export { basicGetStaticProps as getStaticProps } from '../lib/static_props'